import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import Loader from '../../../Restore/components/utility/loader';
import { getCurrentUserPermissions } from '../../../common/apis/permissions-api-new';

const LISTS_PATH = '/sleep/tech';

export function isPhoneBrowser() {
  if (typeof navigator === 'undefined') return false;
  if (navigator.userAgentData && navigator.userAgentData.mobile === true) return true;
  const ua = navigator.userAgent || '';
  return /iPhone|iPod|Android.+Mobile|Windows Phone|IEMobile|BlackBerry/i.test(ua);
}

export async function canViewMyLists() {
  const permissions = await getCurrentUserPermissions();
  const sleepPerms = permissions?.[2] || permissions?.['2'] || {};
  return !!sleepPerms?.Dashboard?.view_my_lists;
}

export default function PhoneEntry({ location, children }) {
  const phone = isPhoneBrowser();
  const [allowed, setAllowed] = useState(false);
  const [checked, setChecked] = useState(!phone);

  useEffect(() => {
    if (!phone) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const canView = await canViewMyLists();
        if (!cancelled) setAllowed(canView);
      } catch (err) {
        console.error('Error checking My Lists access:', err);
        if (!cancelled) setAllowed(false);
      } finally {
        if (!cancelled) setChecked(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [phone]);

  if (!phone) {
    if (location.pathname === LISTS_PATH) return <Redirect to="/home" />;
    return children;
  }
  if (!checked) return <Loader />;
  if (allowed && location.pathname !== LISTS_PATH) {
    return <Redirect to={LISTS_PATH} />;
  }
  return children;
}
